const DeepLinkField = {
  Destination: "Deep Link Destination",
  IsDeepLink: "Is Deep Link?",
  IssueType: "Deep Link Issue Type",
  LifecyclePhase: "Deep Link Lifecycle Phase",
  PauseReason: "Deep Link Pause Reason",
  ResolvedURL: "Deep Link Resolved URL",
  Route: "Deep Link Route",
  URL: "Deep Link URL",
} as const;

const DeepLinkEvent = {
  IssueEncountered: "Deep Link encountered an issue",
  LifecycleEvent: "Deep Link Lifecycle event",
} as const;

const DeepLinkIssues = {
  EmailClickTracking: {
    ResolutionFailure:
      "Deep Link email click tracking URL could not be resolved or opened",
  },
  FeatureFlagDisabled: "Deep Link Route disabled by feature flag",
  MalformedURL: "Deep Link URL is malformed",
  Paused: "Deep Linking momentarily paused",
  RouteNotSupported: "Deep Link Route not supported",
} as const;

const DeepLinkLifecycle = {
  EmailClickTracking: {
    OpenedInBrowser:
      "Deep Link email click tracking URL resolved to a web link, opened in browser",
    Received: "Deep Link email click tracking URL received",
    Resolved: "Deep Link email click tracking URL resolved",
  },
  ProcessingPreLoginLink: "Pre-login Deep Link processing now after login",
  Received: "Deep Link Received by app",
  StartedRouting: "Deep Link Routing started",
  SuccessfullyRouted: "Deep Link successfully routed",
} as const;

const DeepLinkPauseReasons = {
  Backgrounding: "Deep Linking paused since app is backgrounded",
  InactivityTimeoutForegrounding:
    "Deep Linking paused since inactivity timeout is checking whether to run",
  InactivityTimeoutProcessing:
    "Deep Linking paused since inactivity timeout is processing",
  NotLoggedIn: "Deep Linking paused since user is not authenticated",
  NotMarkedReadyPostLogin:
    "Deep Linking paused since not yet marked ready post login",
} as const;

export {
  DeepLinkEvent,
  DeepLinkField,
  DeepLinkIssues,
  DeepLinkLifecycle,
  DeepLinkPauseReasons,
};
